import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  item: null,
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createWebPushSubscriptionNotification({ commit }, item) {
    return this.$axios.$post('admin/webPushSubscriptionNotifications/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeWebPushSubscriptionNotification({ commit }, item) {
    return this.$axios.$delete(`admin/webPushSubscriptionNotifications/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateWebPushSubscriptionNotification({ commit }, item) {
    return this.$axios.$put(`admin/webPushSubscriptionNotifications/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
      return response.data
    })
  },
  fetchWebPushSubscriptionNotification({ commit }, id) {
    return this.$axios.$get(`admin/webPushSubscriptionNotifications/${id}`).then((response) => {
      return response.data
    })
  },
  fetchWebPushSubscriptionNotifications({ commit }) {
    return this.$axios.$get('admin/webPushSubscriptionNotifications').then((response) => {
      commit('load', response.data)
      return response.data
    })
  },
}
